<!--
 * @Author: zyy
 * @Date: 2022-11-17 10:33:19
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-18 11:22:22
 * @Description: default
-->

<template>
    <div>
        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmmodal"
            destroy-on-close centered :width="1000">
            <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="ruleForm">
                <a-form-model-item label="模板名称" prop="name">
                    <a-input v-model="form.name" />
                </a-form-model-item>
                <a-form-model-item label="计价方式" prop="type">
                    <a-radio-group name="radioGroup" v-model="form.type">
                        <a-radio value="number">
                            按件数
                        </a-radio>
                        <a-radio value="weight">
                            按重量
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="运费配置">
                    <a-table :columns="columns" :data-source="form.express" :pagination="false" bordered>

                        <span slot="region" slot-scope="text, record,index" v-if="record">
                            <span class="textline-2" style="max-width: 400px;">{{ record.area_text }}</span>
                            <a-button type="primary" @click="openRegionModal(index)">选择地址</a-button>

                        </span>

                        <span slot="first_num" slot-scope="text, record" v-if="record">
                            <a-input v-model="record.first_num"></a-input>
                        </span>

                        <span slot="first_price" slot-scope="text, record" v-if="record">
                            <a-input v-model="record.first_price"></a-input>
                        </span>

                        <span slot="additional_num" slot-scope="text, record" v-if="record">
                            <a-input v-model="record.additional_num"></a-input>
                        </span>

                        <span slot="additional_price" slot-scope="text, record" v-if="record">
                            <a-input v-model="record.additional_price"></a-input>
                        </span>

                        <span slot="action" slot-scope="text, record,index">
                            <a @click="delTableData(index)">删除</a>
                        </span>
                        <span slot="action" slot-scope="text, record,index">
                            <a @click="delTableData(index)">删除</a>
                        </span>

                    </a-table>
                    <a-button type="link" @click="addTableData">添加</a-button>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <RegionTree ref="regionTreeRef" @submit="getRegionData" />
    </div>

</template>
<script>
import { TJListMixin } from '@/mixins/list.js'
import RegionTree from '@/components/RegionTree.vue'
import LogisticsModelService from "@/io/logistics/model.js";

export default {
    props: ['submit'],
    name: 'modelInfo',
    mixins: [TJListMixin],
    components: {
        RegionTree
    },
    data() {
        return {
            isEdit: false,
            currentIndex: 0,
            form: {
                name: '',
                type: 'number',
                express: []
            },
            modal: {
                loading: false,
                show: false,
                data: [],
                title: '运费模板'
            },
            rules: {
                name: [
                    { required: true, message: '请输入模板名称' },
                ],
                type: [
                    { required: true, message: '请选择计价方式' },
                ],
            },
            columns: [
                {
                    title: "可配送区域",
                    slot: "region",
                    scopedSlots: { customRender: 'region' },
                },
                {
                    title: "首重/件",
                    dataIndex: "first_num",
                    slot: "first_num",
                    scopedSlots: { customRender: 'first_num' },
                },
                {
                    title: "运费(元)",
                    dataIndex: "first_price",
                    slot: "first_price",
                    scopedSlots: { customRender: 'first_price' },
                },
                {
                    title: "续重/件",
                    dataIndex: "additional_num",
                    slot: "additional_num",
                    scopedSlots: { customRender: 'additional_num' },
                },
                {
                    title: "续费(元)",
                    dataIndex: "additional_price",
                    slot: "additional_price",
                    scopedSlots: { customRender: 'additional_price' },
                },
                {
                    title: '操作',
                    scopedSlots: { customRender: 'action' },
                    width: '80px'
                }

            ]
        }
    },
    methods: {
        open(record) {
            if (record) {
                console.log(record)
                this.form = JSON.parse(JSON.stringify(record))
                this.form.type = record.express[0]?.type
                this.form.express.forEach(val => {
                    val.area_ids = val.area_ids.split(',')
                    val.city_ids = val.city_ids.split(',')
                    val.province_ids = val.province_ids.split(',')
                    delete val.deletetime
                })
            } else {
                this.form = {
                    name: '',
                    type: 'number',
                    express: []
                }
            }
            this.modal.show = true

        },
        getRegionData(regionObj, checkTitles) {

            this.form.express[this.currentIndex].area_text = checkTitles.join(', ')
            this.form.express[this.currentIndex].area_ids = regionObj.area_ids
            this.form.express[this.currentIndex].city_ids = regionObj.city_ids
            this.form.express[this.currentIndex].province_ids = regionObj.province_ids
        },
        openRegionModal(index) {
            this.currentIndex = index
            const selectedIds = [
                ...this.form.express[this.currentIndex].area_ids,
                ...this.form.express[this.currentIndex].city_ids,
                ...this.form.express[this.currentIndex].province_ids
            ]
            this.$refs.regionTreeRef.open(selectedIds)
        },
        // 删除参数
        delTableData(index) {
            this.form.express.splice(index, 1)
        },
        // 添加参数
        addTableData() {
            this.form.express.push({
                key: Math.random(),
                first_num: '',
                first_price: '',
                additional_num: '',
                additional_price: '',
                province_ids: [],
                city_ids: [],
                area_ids: [],
                area_text: ''
            })
        },
        confirmmodal() {

            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.form.id) {
                        LogisticsModelService.edit(this.form).then(res => {
                            this.modal.show = false
                            this.$emit('submit')
                        })
                    } else {
                        LogisticsModelService.add(this.form).then(res => {
                            this.modal.show = false
                            this.$emit('submit')
                        })
                    }
                }
            })




        }
    }

}
</script>
<style scoped lang="less">

</style>